import { render, staticRenderFns } from "./AssignSupervisorAdmin.vue?vue&type=template&id=7b2b0115&scoped=true&"
import script from "./AssignSupervisorAdmin.vue?vue&type=script&lang=js&"
export * from "./AssignSupervisorAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AssignSupervisorAdmin.vue?vue&type=style&index=0&id=7b2b0115&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2b0115",
  null
  
)

export default component.exports